import { useCommonQuery } from './common-query';

export const useSiteMetadata = () => {
  const data = useCommonQuery();

  return data.site.siteMetadata;
};
